import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CommonActionUI from './CommonActionUI.js'

class RaiseExceptionSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      successMsg: null,
      errorList: null
    }
  }

  render() {
    return (
      <CommonActionUI
        context={this.props.context}
        title='Raise exception'
        buttonLabel='Submit'
        submitted={this.state.submitted}
        onClick={this.onClick}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
      />
    )
  }

  onClick = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true, errorList: null})

    let context = this.props.context
    let postResource = RestApiUtils.getServerUrl(context) + '/api/system/exception'
    console.log('-> POST', postResource)

    fetch(postResource, {
      method: 'post',
      headers: RestApiUtils.getHeaders(context),
      body: JSON.stringify({})
    })
    .then((response) => {
      console.log('<- POST', postResource)
      if(!response.ok)
        this.onPostCallback()
    })
  }

  onPostCallback = () => {
    this.setState({
      submitted: false,
      successMsg: 'Exception raised',
    })

    setTimeout(() => { this.setState({successMsg: null})}, 2000)
  }
}

export default RaiseExceptionSF
